import { createFileRoute } from '@tanstack/react-router'
import CreateOrEditUserCampaign from '../components/user-campaigns/CreateOrEditUserCampaign'

export const Route = createFileRoute('/_a/campaigns/$campaignId')({
  component: EditUserCampaign,
})

function EditUserCampaign() {
  const { campaignId } = Route.useParams()
  return <CreateOrEditUserCampaign campaignId={campaignId} />
}
